module.exports = __webpack_public_path__ + "img/article_6_3.44ebedaa.png";